import { IModelRaw } from './base';
import { IRegion } from './region.model';

export interface ICompany extends IModelRaw {
  name_vi?: string | null;
  name_en?: string | null;
  logo_url?: string | null;
  secondary_logo?: string | null;
  backdrop_image?: string | null;
  content_images?: string[];
  description_vi?: string | null;
  description_en?: string | null;
  order?: number;
  hidden?: boolean;
  type?: ECompanyType;
  founder_vi?: string;
  founder_en?: string;
  website_vi?: string;
  website_en?: string;
  country?: IRegion | null;
  country_id?: string | null;
}

export enum ECompanyType {
  Building = 'building',
  Industry = 'industry',
  Transport = 'transport',
}
